export { Integrations, init, withSentryConfig } from './client/index.js';
export { nextRouterInstrumentation } from './client/routing/nextRoutingInstrumentation.js';
export { captureUnderscoreErrorException } from './common/_error.js';
export { BrowserTracing, browserTracingIntegration } from './client/browserTracingIntegration.js';
export { withSentryGetStaticProps, wrapGetStaticPropsWithSentry } from './common/wrapGetStaticPropsWithSentry.js';
export { withSentryServerSideGetInitialProps, wrapGetInitialPropsWithSentry } from './common/wrapGetInitialPropsWithSentry.js';
export { withSentryServerSideAppGetInitialProps, wrapAppGetInitialPropsWithSentry } from './common/wrapAppGetInitialPropsWithSentry.js';
export { withSentryServerSideDocumentGetInitialProps, wrapDocumentGetInitialPropsWithSentry } from './common/wrapDocumentGetInitialPropsWithSentry.js';
export { withSentryServerSideErrorGetInitialProps, wrapErrorGetInitialPropsWithSentry } from './common/wrapErrorGetInitialPropsWithSentry.js';
export { withSentryGetServerSideProps, wrapGetServerSidePropsWithSentry } from './common/wrapGetServerSidePropsWithSentry.js';
export { wrapServerComponentWithSentry } from './common/wrapServerComponentWithSentry.js';
export { wrapRouteHandlerWithSentry } from './common/wrapRouteHandlerWithSentry.js';
export { wrapApiHandlerWithSentryVercelCrons } from './common/wrapApiHandlerWithSentryVercelCrons.js';
export { wrapMiddlewareWithSentry } from './common/wrapMiddlewareWithSentry.js';
export { wrapPageComponentWithSentry } from './common/wrapPageComponentWithSentry.js';
export { wrapGenerationFunctionWithSentry } from './common/wrapGenerationFunctionWithSentry.js';
export { withServerActionInstrumentation } from './common/withServerActionInstrumentation.js';
export * from '@sentry/react';
export { rewriteFramesIntegration } from './client/rewriteFramesIntegration.js';

// This file is the main entrypoint for non-Next.js build pipelines that use
// the package.json's "browser" field or the Edge runtime (Edge API routes and middleware)

/**
 * This const serves no purpose besides being an identifier for this file that the SDK multiplexer loader can use to
 * determine that this is in fact a file that wants to be multiplexed.
 */
const _SENTRY_SDK_MULTIPLEXER = true;

export { _SENTRY_SDK_MULTIPLEXER };
//# sourceMappingURL=index.client.js.map
